export enum AppDomains {
	registration = 'registration',
	producer = 'producer',
}
export type AppDomainContextType = AppDomains.registration | AppDomains.producer | null;
